import { PagesApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function usePagesAPI(): PagesApi {
  return new PagesApi(apiConfig);
}
